import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "@/data/store";

export const selectSocraticState = (state: RootState) => state.socratic;
export const selectSocraticDialogueState = (state: RootState) =>
  state.socratic.dialogueTimeline;

export const selectPreparationEndDate = createSelector(
  selectSocraticState,
  (socratic) => socratic.dialogueTimeline.preparationEndDate.date
);

export const selectPreparationEndDatePassed = createSelector(
  selectSocraticState,
  (socratic) => socratic.dialogueTimeline.preparationEndDate.passed
);

export const selectResponseEndDate = createSelector(
  selectSocraticState,
  (socratic) => socratic.dialogueTimeline.responseEndDate.date
);

export const selectResponseEndDatePassed = createSelector(
  selectSocraticState,
  (socratic) => socratic.dialogueTimeline.responseEndDate.passed
);

export const selectReattemptWindowEndDate = createSelector(
  selectSocraticState,
  (socratic) => socratic.reattemptWindowEndDate.date
);

export const selectReattemptWindowEndDatePassed = createSelector(
  selectSocraticState,
  (socratic) => socratic.reattemptWindowEndDate.passed
);

export const selectRecordingStartCutoffDate = createSelector(
  selectSocraticState,
  (socratic) => socratic.recordingStartCutoffDate.date
);

export const selectRecordingStartCutoffDatePassed = createSelector(
  selectSocraticState,
  (socratic) => socratic.recordingStartCutoffDate.passed
);

export const selectCameraRequiredDisabled = createSelector(
  selectSocraticState,
  (socratic) => socratic.cameraRequiredDisabled
);

export const selectIsUploading = createSelector(
  selectSocraticState,
  (socratic) => socratic.isUploading
);
